var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeftMiddle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "106px",
    height: "91px",
    viewBox: "0 0 106 91",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pixagri",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Aide-4",
    transform: "translate(-285.000000, -422.000000)",
    stroke: "#9EBE4A",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(337.897239, 467.165008) scale(1, -1) rotate(30.000000) translate(-337.897239, -467.165008) translate(293.819759, 443.264668)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Line-21",
    strokeLinejoin: "round",
    transform: "translate(83.061724, 4.925188) rotate(-22.000000) translate(-83.061724, -4.925188) ",
    points: "79.061724 1.22930652 87.061724 1.22930652 87.061724 8.62106974"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.04870979e-29,39.2181509 C18.2431023,48.2289038 33.6399723,50.1443996 46.1906101,44.9646385 C63.3576547,37.8796447 76.1875317,23.3796447 84.6802413,1.46463846",
    id: "Line-8"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftMiddle);
export default __webpack_public_path__ + "static/media/arrow_left_middle.94e86ad8.svg";
export { ForwardRef as ReactComponent };